import { Badge } from '@roger/ui-components';

/**
 * Canonical tooltip for the inactive-episode marker. An inactive
 * (cancelled) episode is one that did not happen; its cycles stay out of
 * Billing Manager unless the page-wide toggle or a direct link brings them in,
 * and the badge says why such a row is here at all.
 */
export const INACTIVE_EPISODE_BADGE_TITLE =
  'This episode was inactivated. Its cycles are hidden unless Show inactive episodes is on.';

interface InactiveEpisodeBadgeProps {
  /** Layout-only classes for the call site (e.g. `self-start` in a flex column). */
  className?: string;
}

/**
 * Single source of truth for the inactive-episode marker — label, styling, and
 * tooltip — shared by every Billing Manager tab. Render conditionally on
 * `episode_status === 'cancelled'` (completed and interrupted episodes did
 * happen and get no badge); this component does not gate itself, so the caller
 * stays in control of when the marker appears.
 */
export function InactiveEpisodeBadge({ className }: InactiveEpisodeBadgeProps) {
  return (
    <Badge
      variant='destructive'
      className={['whitespace-nowrap', className].filter(Boolean).join(' ')}
      title={INACTIVE_EPISODE_BADGE_TITLE}
    >
      Inactive Episode
    </Badge>
  );
}
